import { DEFAULT_LANGUAGE, LANGUAGES } from "@/const/languages";

export const SUPPORT_EMAIL = "support@apily.pro";
export const SUPPORT_MAILTO = `mailto:${SUPPORT_EMAIL}`;
export const SUPPORT_TELEGRAM_BOT_URL = "https://t.me/Apilysupportbot";
export const SUPPORT_TELEGRAM_CHANNEL_URL = "https://t.me/apilyNews";

export const LEGAL_DOCS = [
  { slug: "terms", titleKey: "legal_terms_title" },
  { slug: "privacy", titleKey: "legal_privacy_title" },
  { slug: "refund", titleKey: "legal_refund_title" },
  { slug: "aup", titleKey: "legal_aup_title" },
  { slug: "dpa", titleKey: "legal_dpa_title" },
];

export const DEFAULT_LEGAL_SLUG = "terms";
export const LEGAL_ORIGINAL_LANGUAGE = DEFAULT_LANGUAGE;

const LEGAL_LANGUAGES = LANGUAGES.map(({ code }) => code);

export function legalPath(slug) {
  return `/legal/${slug}`;
}

export function getLegalDoc(slug) {
  return LEGAL_DOCS.find((doc) => doc.slug === slug) || null;
}

export function resolveLegalLanguage(lang) {
  if (LEGAL_LANGUAGES.includes(lang)) return lang;
  const base = (lang || "").split("-")[0];
  return LEGAL_LANGUAGES.find((code) => code.split("-")[0] === base) || LEGAL_ORIGINAL_LANGUAGE;
}

// One chunk per language and document: a visitor downloads only the text they open.
export async function loadLegalContent(lang, slug) {
  if (!getLegalDoc(slug)) return null;
  const module = await import(`./content/${resolveLegalLanguage(lang)}/${slug}.js`);
  return module.default;
}

// The source documents cross-link each other as sibling files (`terms.md`); map those to app routes.
export function resolveLegalHref(href) {
  const match = /^(?:\.\/)?([a-z]+)\.md(#.*)?$/.exec(href || "");
  if (match && getLegalDoc(match[1])) {
    return { internal: true, href: `${legalPath(match[1])}${match[2] || ""}` };
  }
  return { internal: false, href };
}
